var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "loading-fade" } }, [
    _vm.visible
      ? _c("div", { staticClass: "customize-loading" }, [
          _c("div", { staticClass: "loading-wrap" }, [
            _c("span", { staticClass: "dot dot-spin" }, [
              _c("i"),
              _c("i"),
              _c("i"),
              _c("i"),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }